__turbopack_context__.v({
  "bestPractices": "OfficeHoursDialog-module-scss-module__p2g9pa__bestPractices",
  "bestPracticesTitle": "OfficeHoursDialog-module-scss-module__p2g9pa__bestPracticesTitle",
  "checkbox": "OfficeHoursDialog-module-scss-module__p2g9pa__checkbox",
  "checkboxLabel": "OfficeHoursDialog-module-scss-module__p2g9pa__checkboxLabel",
  "checkboxText": "OfficeHoursDialog-module-scss-module__p2g9pa__checkboxText",
  "checkboxWrapper": "OfficeHoursDialog-module-scss-module__p2g9pa__checkboxWrapper",
  "closeButton": "OfficeHoursDialog-module-scss-module__p2g9pa__closeButton",
  "content": "OfficeHoursDialog-module-scss-module__p2g9pa__content",
  "continueButton": "OfficeHoursDialog-module-scss-module__p2g9pa__continueButton",
  "description": "OfficeHoursDialog-module-scss-module__p2g9pa__description",
  "dialog": "OfficeHoursDialog-module-scss-module__p2g9pa__dialog",
  "footer": "OfficeHoursDialog-module-scss-module__p2g9pa__footer",
  "iconWrapper": "OfficeHoursDialog-module-scss-module__p2g9pa__iconWrapper",
  "overlay": "OfficeHoursDialog-module-scss-module__p2g9pa__overlay",
  "practiceContent": "OfficeHoursDialog-module-scss-module__p2g9pa__practiceContent",
  "practiceIcon": "OfficeHoursDialog-module-scss-module__p2g9pa__practiceIcon",
  "practiceItem": "OfficeHoursDialog-module-scss-module__p2g9pa__practiceItem",
  "practiceText": "OfficeHoursDialog-module-scss-module__p2g9pa__practiceText",
  "practiceTitle": "OfficeHoursDialog-module-scss-module__p2g9pa__practiceTitle",
  "title": "OfficeHoursDialog-module-scss-module__p2g9pa__title",
});
